import { useTranslation } from "react-i18next";

export const useRouteItems = () => {
    const { t } = useTranslation();

    return {
        dashboard: {
            main: {
                base: t('routes.dashboard.base.main'),
                label: t('routes.dashboard.labels.main'),
                paths: t('routes.dashboard.paths.main'),
            },
        },
        logbook: {
          main: {
            base: t('routes.logbook.base.main'),
            label: t('routes.logbook.labels.main'),
            paths: t('routes.logbook.paths.main'),
          }
        },
        filesManager: {
          main: {
            base: t('routes.filesManager.base.main'),
            label: t('routes.filesManager.labels.main'),
            paths: t('routes.filesManager.paths.main'),
          }
        },
        logbook: {
          main: {
            base: t('routes.logbook.base.main'),
            label: t('routes.logbook.labels.main'),
            paths: t('routes.logbook.paths.main'),
          }
        },
        reports: {
            main: {
                base: t('routes.reports.base.main'),
                label: t('routes.reports.labels.main'),
                paths: t('routes.reports.paths.main'),
            },
            programmed: {
                base: t('routes.reports.base.programmed'),
                label: t('routes.reports.labels.programmed'),
                paths: t('routes.reports.paths.programmed'),
            },
            programation: {
                base: t('routes.reports.base.programation'),
                label: t('routes.reports.labels.programation'),
                paths: t('routes.reports.paths.programation'),
            },
            'progress-questionnaire': {
                base: t('routes.reports.base.progress-questionnaire'),
                label: t('routes.reports.labels.progress-questionnaire'),
                paths: t('routes.reports.paths.progress-questionnaire'),
            },
        },
        'organization-chart': {
            main: {
                base: t('routes.organization-chart.base.main'),
                label: t('routes.organization-chart.labels.main'),
                paths: t('routes.organization-chart.paths.main'),
            },
            area: {
                base: t('routes.organization-chart.base.area'),
                label: t('routes.organization-chart.labels.area'),
                paths: t('routes.organization-chart.paths.area'),
            },
            departments: {
                base: t('routes.organization-chart.base.departments'),
                label: t('routes.organization-chart.labels.departments'),
                paths: t('routes.organization-chart.paths.departments'),
            },
            'area-department': {
                base: t('routes.organization-chart.base.area-department'),
                label: t('routes.organization-chart.labels.area-department'),
                paths: t('routes.organization-chart.paths.area-department'),
            },
        },
        service: {
            main: {
                base: t('routes.service.base.main'),
                label: t('routes.service.labels.main'),
                paths: t('routes.service.paths.main'),
            },
            'area-department': {
                base: t('routes.service.base.area-department'),
                label: t('routes.service.labels.area-department'),
                paths: t('routes.service.paths.area-department'),
            },
            catalog: {
                base: t('routes.service.base.catalog'),
                label: t('routes.service.labels.catalog'),
                paths: t('routes.service.paths.catalog'),
            },
            'time-config': {
                base: t('routes.service.base.time-config'),
                label: t('routes.service.labels.time-config'),
                paths: t('routes.service.paths.time-config'),
            },
        },
        user: {
            main: {
                base: t('routes.user.base.main'),
                label: t('routes.user.labels.main'),
                paths: t('routes.user.paths.main'),
            },
            register: {
                base: t('routes.user.base.register'),
                label: t('routes.user.labels.register'),
                paths: t('routes.user.paths.register'),
            },
            'user-type': {
                base: t('routes.user.base.user-type'),
                label: t('routes.user.labels.user-type'),
                paths: t('routes.user.paths.user-type'),
            },
            'group-gestion': {
                base: t('routes.user.base.group-gestion'),
                label: t('routes.user.labels.group-gestion'),
                paths: t('routes.user.paths.group-gestion'),
            },
        },
        unit: {
            main: {
                base: t('routes.unit.base.main'),
                label: t('routes.unit.labels.main'),
                paths: t('routes.unit.paths.main'),
            },
            store: {
                base: t('routes.unit.base.store'),
                label: t('routes.unit.labels.store'),
                paths: t('routes.unit.paths.store'),
            },
            division: {
                base: t('routes.unit.base.division'),
                label: t('routes.unit.labels.division'),
                paths: t('routes.unit.paths.division'),
            },
            zone: {
                base: t('routes.unit.base.zone'),
                label: t('routes.unit.labels.zone'),
                paths: t('routes.unit.paths.zone'),
            },
        },
        questionnarie: {
            main: {
                base: t('routes.questionnarie.base.main'),
                label: t('routes.questionnarie.labels.main'),
                paths: t('routes.questionnarie.paths.main'),
            },
        },
        calendar: {
            main: {
                base: t('routes.calendar.base.main'),
                label: t('routes.calendar.labels.main'),
                paths: t('routes.calendar.paths.main'),
            },
        },
        'schedule-user': {
            main: {
                base: t('routes.schedule-user.base.main'),
                label: t('routes.schedule-user.labels.main'),
                paths: t('routes.schedule-user.paths.main'),
            },
        },
        'action-plan': {
            main: {
                base: t('routes.action-plan.base.main'),
                label: t('routes.action-plan.labels.main'),
                paths: t('routes.action-plan.paths.main'),
            },
            created: {
                base: t('routes.action-plan.base.created'),
                label: t('routes.action-plan.labels.created'),
                paths: t('routes.action-plan.paths.created'),
            },
            'to-generate': {
                base: t('routes.action-plan.base.to-generate'),
                label: t('routes.action-plan.labels.to-generate'),
                paths: t('routes.action-plan.paths.to-generate'),
            },
        },
        'report-folio': {
            main: {
                base: t('routes.report-folio.base.main'),
                label: t('routes.report-folio.labels.main'),
                paths: t('routes.report-folio.paths.main'),
            },
            dashboard: {
                base: t('routes.report-folio.base.dashboard'),
                label: t('routes.report-folio.labels.dashboard'),
                paths: t('routes.report-folio.paths.dashboard'),
            },
            settings: {
                base: t('routes.report-folio.base.settings'),
                label: t('routes.report-folio.labels.settings'),
                paths: t('routes.report-folio.paths.settings'),
            },
            'catalog': {
                base: t('routes.report-folio.base.catalog'),
                label: t('routes.report-folio.labels.catalog'),
                paths: t('routes.report-folio.paths.catalog'),
            }
        },
        setting: {
            main: {
                base: t('routes.setting.base.main'),
                label: t('routes.setting.labels.main'),
                paths: t('routes.setting.paths.main'),
            },
            'admin-users': {
                base: t('routes.setting.base.admin-users'),
                label: t('routes.setting.labels.admin-users'),
                paths: t('routes.setting.paths.admin-users'),
            },
            'option-group': {
                base: t('routes.setting.base.option-group'),
                label: t('routes.setting.labels.option-group'),
                paths: t('routes.setting.paths.option-group'),
            },
            companies: {
                base: t('routes.setting.base.companies'),
                label: t('routes.setting.labels.companies'),
                paths: t('routes.setting.paths.companies'),
            },
            dropList: {
                base: t('routes.setting.base.dropList'),
                label: t('routes.setting.labels.dropList'),
                paths: t('routes.setting.paths.dropList'),
            },
        },
        localization: {
            main: {
                base: t('routes.localization.base.main'),
                label: t('routes.localization.labels.main'),
                paths: t('routes.localization.paths.main'),
            },
        },
    };
};
